module.exports = __webpack_public_path__ + "static/media/healthArticle1.3abadec5.jpg";